import { storage } from './utils/storage.js';
import {
  displayLanguageFromSeoPath,
  seoHrefForLanguage,
  seoPathForLanguage,
} from './seoLocalePath.js';

const pathLanguage = displayLanguageFromSeoPath(window.location.pathname);
if (pathLanguage) {
  storage.set('displayLanguage', pathLanguage);
}

const normalizePathname = (pathname) => {
  const trimmed = (pathname || '/').replace(/\/+$/, '');
  return trimmed || '/';
};

const currentDisplayLanguage = () => storage.getLanguage();

const landingTarget = () => {
  const nextPath = seoPathForLanguage(window.location.pathname, currentDisplayLanguage());
  if (!nextPath) return null;
  if (nextPath === normalizePathname(window.location.pathname)) return null;
  return `${nextPath}${window.location.search}${window.location.hash}`;
};

const landingUrl = landingTarget();
if (landingUrl) {
  window.location.replace(landingUrl);
} else {
  const rewriteCompareHrefs = () => {
    const language = currentDisplayLanguage();
    document.querySelectorAll('a[href]').forEach((anchor) => {
      const nextHref = seoHrefForLanguage(anchor.getAttribute('href'), language);
      if (nextHref) anchor.setAttribute('href', nextHref);
    });
  };

  const handleCompareLinkClick = (event) => {
    if (event.defaultPrevented || event.button !== 0) return;
    if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const anchor = event.target instanceof Element ? event.target.closest('a[href]') : null;
    if (!anchor || anchor.target === '_blank' || anchor.hasAttribute('download')) return;
    const nextHref = seoHrefForLanguage(anchor.getAttribute('href'), currentDisplayLanguage());
    if (!nextHref) return;
    event.preventDefault();
    window.location.assign(nextHref);
  };

  rewriteCompareHrefs();
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', rewriteCompareHrefs);
  }
  document.addEventListener('languageChanged', rewriteCompareHrefs);
  document.addEventListener('click', handleCompareLinkClick, true);
}
